var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: {
        title: _vm.$t("setting.heading"),
        confirm: false,
        closeMessage: _vm.$t("setting.close"),
        xs: "",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "form-horizontal" }, [
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            { staticClass: "col-xs-3", attrs: { for: "resultsPerPage" } },
            [_vm._v(_vm._s(_vm.$t("setting.resultsPerPage")) + ":")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.lazy",
                  value: _vm.pageSize,
                  expression: "pageSize",
                  modifiers: { lazy: true },
                },
              ],
              staticClass: "form-control",
              attrs: {
                type: "number",
                id: "resultsPerPage",
                name: "resultsPerPage",
                min: "1",
                max: "1000",
                list: "resultsPerPageOptions",
              },
              domProps: { value: _vm.pageSize },
              on: {
                change: function ($event) {
                  _vm.pageSize = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("datalist", { attrs: { id: "resultsPerPageOptions" } }, [
              _c("option", { attrs: { value: "20" } }),
              _vm._v(" "),
              _c("option", { attrs: { value: "50" } }),
              _vm._v(" "),
              _c("option", { attrs: { value: "100" } }),
              _vm._v(" "),
              _c("option", { attrs: { value: "200" } }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            { staticClass: "col-xs-3", attrs: { for: "sampleSize" } },
            [_vm._v(_vm._s(_vm.$t("setting.sampleSize")) + ":")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-9" }, [
            _c(
              "div",
              { staticClass: "input-group" },
              [
                _c("SelectPicker", {
                  staticClass: "input-group-btn",
                  attrs: {
                    "data-id": "sampleMode",
                    "data-name": "sampleMode",
                    "data-menu-width": "grow",
                    hideEmpty: "",
                    options: _vm.sampleModeOptions,
                  },
                  on: { input: _vm.focusSampleSize },
                  model: {
                    value: _vm.sampleMode,
                    callback: function ($$v) {
                      _vm.sampleMode = $$v
                    },
                    expression: "sampleMode",
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.lazy",
                      value: _vm.sampleSize,
                      expression: "sampleSize",
                      modifiers: { lazy: true },
                    },
                  ],
                  ref: "sampleSize",
                  staticClass: "form-control",
                  attrs: {
                    id: "sampleSize",
                    name: "sampleSize",
                    placeholder: _vm.$t("setting.sampleSize"),
                    type: "number",
                  },
                  domProps: { value: _vm.sampleSize },
                  on: {
                    change: function ($event) {
                      _vm.sampleSize = $event.target.value
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            { staticClass: "col-xs-3", attrs: { for: "sampleSeed" } },
            [_vm._v(_vm._s(_vm.$t("setting.sampleSeed")) + ":")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.lazy",
                  value: _vm.sampleSeed,
                  expression: "sampleSeed",
                  modifiers: { lazy: true },
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "sampleSeed",
                name: "sampleSeed",
                placeholder: _vm.$t("setting.sampleSeed"),
                type: "number",
              },
              domProps: { value: _vm.sampleSeed },
              on: {
                change: function ($event) {
                  _vm.sampleSeed = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { staticClass: "col-xs-3", attrs: { for: "context" } }, [
            _vm._v(_vm._s(_vm.$t("setting.context")) + ":"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-9" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.lazy",
                  value: _vm.context,
                  expression: "context",
                  modifiers: { lazy: true },
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "context",
                name: "context",
                placeholder: _vm.$t("setting.context"),
                type: "number",
              },
              domProps: { value: _vm.context },
              on: {
                change: function ($event) {
                  _vm.context = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "checkbox-inline" }, [
        _c("label", { attrs: { for: "wide-view" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.wideView.value,
                expression: "wideView.value",
              },
            ],
            attrs: { type: "checkbox", id: "wide-view", name: "wide-view" },
            domProps: {
              checked: Array.isArray(_vm.wideView.value)
                ? _vm._i(_vm.wideView.value, null) > -1
                : _vm.wideView.value,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.wideView.value,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 &&
                      _vm.$set(_vm.wideView, "value", $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.wideView,
                        "value",
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.wideView, "value", $$c)
                }
              },
            },
          }),
          _vm._v(_vm._s(_vm.$t("setting.wideView"))),
        ]),
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.debug.debug_visible || _vm.debug.debug
        ? [
            _c("div", { staticClass: "checkbox-inline" }, [
              _c(
                "label",
                { staticClass: "text-muted", attrs: { for: "debug" } },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.debug.debug,
                        expression: "debug.debug",
                      },
                    ],
                    attrs: { type: "checkbox", id: "debug", name: "debug" },
                    domProps: {
                      checked: Array.isArray(_vm.debug.debug)
                        ? _vm._i(_vm.debug.debug, null) > -1
                        : _vm.debug.debug,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.debug.debug,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.debug, "debug", $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.debug,
                                "debug",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.debug, "debug", $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(_vm._s(_vm.$t("setting.debug"))),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-default",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.debug.debug_visible = false
                    _vm.debug.debug = false
                  },
                },
              },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("setting.hideDebugUntilReload")) +
                    "\n\t\t"
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }